import type { PricingQuote } from './types';

const deadlines = new WeakMap<PricingQuote, number>();
/** Use server time and a monotonic timer; the server always enforces expiry at admission. */
export function registerQuoteClock(quote: PricingQuote, serverDate: string | null) {
  const serverNow = serverDate ? Date.parse(serverDate) : NaN;
  const remaining = Number.isFinite(serverNow)
    ? Math.max(0, Date.parse(quote.expires_at) - serverNow)
    : 600_000; // Contract TTL when CORS hides Date; never compare with the device wall clock.
  deadlines.set(quote, performance.now() + Math.min(remaining, 600_000));
}
export function quoteRemainingMs(quote: PricingQuote): number {
  const deadline = deadlines.get(quote);
  return deadline === undefined ? Infinity : Math.max(0, deadline - performance.now());
}
